export const MAC_FONT_SCALES = [0.85, 1, 1.15, 1.3, 1.5];

export function normalizeMacFontScale(value) {
  return MAC_FONT_SCALES.includes(value) ? value : 1;
}

// Scale explicit typography only. Nested spans inherit already-scaled values;
// margins, padding and container dimensions keep their normal layout units.
export function scaleTextStyle(style, scale) {
  if (!style || scale === 1) return style;
  const next = { ...style };
  for (const key of ['fontSize', 'lineHeight']) {
    if (Number.isFinite(style[key])) next[key] = style[key] * scale;
  }
  return next;
}

export function scaleTextStyles(styles, scale) {
  if (scale === 1) return styles;
  return Object.fromEntries(Object.entries(styles).map(([key, style]) => [key, scaleTextStyle(style, scale)]));
}
